import React from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { themeOptions } from '../../theme';

const lightTheme = createTheme(themeOptions(true) as any);

const LightThemePage = ({ children }: { children: React.ReactNode }) => {
    return (
        <ThemeProvider theme={lightTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default LightThemePage;